import api from 'api';
import axios from 'axios';
import { FC, useContext, useEffect, useState } from 'react';

// Libraries
import moment from 'moment-timezone';

import { debug } from 'utils/helpers';

import { EventContext } from 'state/contexts/event';

import { Event } from 'components/elements';
import MainProfileActions from 'components/main';
import { PatientContext } from 'state/contexts/patient';
import { ActionTypes } from 'state/reducers/event';

type EventNote = {
  id: number;
  name: string;
  start_date: string;
  end_date?: string;
  pinned: boolean;
};

const EventNotes: FC = () => {
  const { eventState, eventDispatch } = useContext(EventContext);
  const { patientState } = useContext(PatientContext);
  const { id: patientId, uuid: patientUuid } = patientState.current!;

  const [events, setEvents] = useState<EventNote[]>([]);

  const source = axios.CancelToken.source();

  const handleClose = async (id: number) => {
    try {
      eventDispatch({
        type: ActionTypes.Update,
        payload: {
          patientId,
          id,
        },
      });
      await api().put(`patients/${patientUuid}/events/${id}/?auth_token=AUTH_TOKEN&pinned=false`);
    } catch (err) {
      debug(`Error: ${err}`);
    }
  };

  const getEventNotes = async () => {
    try {
      const { data } = await api().get(`/patients/${patientUuid}/events?auth_token=AUTH_TOKEN`);

      eventDispatch({
        type: ActionTypes.Set,
        payload: {
          patientId,
          data: data?.filter((event: EventNote) => event.pinned),
        },
      });
    } catch (err) {
      if (!axios.isCancel(err)) {
        debug(`Error: ${err}`);
      }
    }
  };

  useEffect(() => {
    setEvents(eventState.data[patientId] || []);
  }, [eventState.data, patientId]);

  useEffect(() => {
    if (eventState.reload !== 0) {
      setTimeout(() => {
        getEventNotes();
      }, 1000);
    }
  }, [eventState.reload]);

  useEffect(() => {
    setEvents([]);
    getEventNotes();

    return () => {
      source.cancel();
    };
  }, [patientId]);

  return (
    <>
      <MainProfileActions />
      {events.map((event) => (
        <Event
          key={`event-${event.id}`}
          backgroundColor='turquoise'
          color='teal'
          onClose={() => handleClose(event.id)}>
          Event:{' '}
          {event.end_date
            ? `${event.name} (${moment(event.start_date).format('MM/DD/YYYY')} - ${moment(
                event.end_date
              ).format('MM/DD/YYYY')})`
            : `${event.name} (${moment(event.start_date).format('MM/DD/YYYY')})`}
        </Event>
      ))}
    </>
  );
};

export default EventNotes;
